import getApi from '@/lib/axios';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getConsolidationDataByType(type: string, year?: string): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const params = {
    type,
  };

  // if(year) {
  //   // @ts-ignore
  //   params.year = year
  // }

  const { data } = await api.get<ConsolidationSummaryType>('/consolidacao/get_consolidation_data/', { params });
  return data;
}

export { getConsolidationDataByType };
